<button
    class="
        px-6
        py-2.5
        rounded-full
        inline-flex
        justify-center
        items-center
        gap-2
        shrink-0
        focus:outline-none
        disabled:cursor-not-allowed
        focus:ring-4
        cursor-pointer
    "
    [disabled]="disabled || settings?.disabled"
    [ngClass]="{
        'h-9':                                !condensed,
        'h-6':                                condensed,
        'bg-dat-blue-500':                  primary,
        'hover:bg-dat-blue-400':            primary,
        'active:bg-dat-blue-700':           primary,
        'border':                             secondary,
        'border-solid':                       secondary,
        'border-dat-blue-400':              secondary,
        'focus:ring-dat-blue-500/10':       secondary,
        'bg-white':                           secondary,
        'bg-dat-signal-red-500':            danger,
        'hover:bg-dat-signal-red-400':      danger,
        'active:bg-dat-signal-red-700':     danger,
        'text-dat-signal-red-500':          dangerGhost,
        'hover:bg-dat-signal-red-050':      dangerGhost,
        'active:bg-dat-signal-red-100':     dangerGhost,
        'active:text-dat-signal-red-700':   dangerGhost,
        'text-white':                       primary   || danger,
        'disabled:text-dat-grey-400':       primary   || danger,
        'disabled:bg-dat-grey-050':         primary   || danger,
        'disabled:border':                    primary   || danger,
        'disabled:border-solid':              primary   || danger,
        'text-dat-blue-500':                secondary || tertiary,
        'hover:bg-dat-blue-500/5':          secondary || tertiary,
        'active:bg-dat-blue-100':           secondary || tertiary,
        'active:text-dat-blue-700':         secondary || tertiary,
        'focus:ring-dat-blue-050':          primary   || tertiary,
        'focus:ring-dat-signal-red-100':    danger    || dangerGhost,
        'disabled:border-dat-grey-100':     primary   || secondary || danger,
        'disabled:text-dat-grey-300':       secondary || tertiary  || dangerGhost,
        'disabled:bg-white':                secondary || tertiary  || dangerGhost,
    }"
    [attr.data-testid]="settings?.id"
    (click)="click()"
>
    <ng-container *ngIf="settings?.icon">
        <mat-icon
            class="!w-4 !h-4"
            [svgIcon]="settings?.icon"
        ></mat-icon>
    </ng-container>
    <span
        class="
            uppercase
            font-button
        "
    >
        {{ settings?.label }}
    </span>
</button>
